import { PublicLayout } from '../layout/PublicLayout';
import { useSEO } from '@/hooks/useSEO';
import { LEGAL_CONFIG, LEGAL_ROUTES } from './legalConfig';
import { cookieHtml } from './legalContent';

export const CookiePolicyPage = () => {
  useSEO({
    title: `Cookie Policy - ${LEGAL_CONFIG.companyName}`,
    description: `Cookie Policy - ${LEGAL_CONFIG.companyName}`,
    keywords: 'cookie policy',
    ogTitle: `Cookie Policy - ${LEGAL_CONFIG.companyName}`,
    ogDescription: `Cookie Policy - ${LEGAL_CONFIG.companyName}`,
    ogType: 'website',
    canonicalUrl: `https://${LEGAL_CONFIG.domain}${LEGAL_ROUTES.cookie}`,
  });

  return (
    <PublicLayout>
      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div
          className="prose prose-slate dark:prose-invert max-w-none space-y-8"
          dangerouslySetInnerHTML={{ __html: cookieHtml }}
        />
      </article>
    </PublicLayout>
  );
};
